export class FileUploadEvent {
    referenceId: number;
    url: string;
}
